export type CreditLimitHitInput = {
  limitType: string
  remainingCredits: number | null | undefined
  userId: string | null | undefined
  orgId: string | null | undefined
  planName: string | null | undefined
  currentPeriodEnd: number | null | undefined
}

export type CreditLimitHitData = {
  transaction_id: string
  user_id?: string
  org_id?: string
  limit_type: 'credits'
  current_plan: string
  usage_percent: 100
}

/**
 * Build the event only when the billing snapshot says the plan has no credits
 * left. A request that merely costs more than the remaining balance is not the
 * lifecycle milestone "runs out of credits" and must not be counted as one.
 */
export function buildCreditLimitHitEvent(
  input: CreditLimitHitInput
): CreditLimitHitData | null {
  if (
    input.limitType !== 'credits' ||
    typeof input.remainingCredits !== 'number' ||
    input.remainingCredits > 0
  ) {
    return null
  }

  return {
    transaction_id: `usage-limit-${input.orgId ?? input.userId ?? 'unknown'}-${input.currentPeriodEnd ?? 'noPeriod'}`,
    ...(input.userId ? { user_id: input.userId } : {}),
    ...(input.orgId ? { org_id: input.orgId } : {}),
    limit_type: 'credits',
    current_plan: input.planName ?? 'Free',
    usage_percent: 100,
  }
}

export function buildCreditLimitHitDedupKey(input: {
  orgId: string | null | undefined
  currentPeriodEnd: number | null | undefined
}): string {
  const orgKey = input.orgId ?? 'noOrg'
  const periodKey = input.currentPeriodEnd ?? 'noPeriod'
  return `gtmCreditLimitHitFired:${orgKey}:${periodKey}`
}
